import React from 'react';
import { IconPropsDeprecated } from '@umanforge/common';
import { NewsCheckSVG } from '@common_components/svg/newsCheck.svg';

const NewsCheckIcon: React.FC<IconPropsDeprecated> = ( { className = '', size = 7, onClick } ) => {
  return (
    <div className={`${className} rotate-180 w-${size} h-${size}`} onClick={onClick}>
      <NewsCheckSVG/>
    </div>
  );
};

export { NewsCheckIcon };
